import { type CybusService, StatusType } from '../../../../../../../domain'

import { type BackendDefinition, mapToStatusType } from '../../../../../../Connectware'

type Info = Pick<BackendDefinition<'service-manager', 'Service'>, 'serviceId' | 'name' | 'currentState' | 'version'>

export const mapBaseService = ({ serviceId, name, currentState, version }: Info, isDeviated: boolean): Omit<CybusService, 'links'> => {
    const status = mapToStatusType(currentState)
    return {
        id: serviceId,
        name,
        version: version || null,
        status,
        deviation: isDeviated ? StatusType.DEVIATED : status === StatusType.DISABLED ? StatusType.NOT_ENABLED : StatusType.NO_DEVIATION,
    }
}
